import { render, staticRenderFns } from "./rhServiceMember.vue?vue&type=template&id=6b412f4e"
import script from "./rhServiceMember.vue?vue&type=script&lang=js"
export * from "./rhServiceMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports